import { useEffect, useState, useRef } from "react";

export default function SolutionTabs({
  tabs,
  activeOnStart = 0,
  currentActiveName,
  onSelectTab,
}) {
  const [activeTab, setActiveTab] = useState(activeOnStart);

  const tabsArray = tabs;

  const prevActiveNameRef = useRef();

  const activeTabHandler = (key, index) => {
    setActiveTab(index);
    onSelectTab(key, index);
  };

  // Седалть активной вкалдку по имени, при его изменение в родительском компоненте
  useEffect(() => {
    if (!currentActiveName) return;

    if (prevActiveNameRef.current !== currentActiveName) {
      const index = tabsArray.indexOf(currentActiveName);
      activeTabHandler(currentActiveName, index);
    }

    prevActiveNameRef.current = currentActiveName;
  }, [currentActiveName]);

  return (
    <div className="solution-tabs-container flex-row flex-center">
      <div className="solution-tabs">
        {tabsArray.map((key, index) => (
          <div
            className={`tab__item border-radius-s ${
              activeTab === index ? "active" : ""
            }`}
            key={index}
            onClick={(e) => activeTabHandler(key, index)}
          >
            <h4>{key}</h4>
          </div>
        ))}
      </div>
    </div>
  );
}
